import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router, Route } from '@angular/router';
import { Observable } from 'rxjs';
import { LoginService } from '../services/login.service';
import { AppServiceService, Data } from '../services/app-service.service';
import { AuthGuard } from './auth.guard';
import { LocalSaveService } from '../services/local-save-service.service';

@Injectable({
  providedIn: 'root'
})

export class RoleGuard implements CanActivate {
  
  constructor(
  	private _router: Router,
    private _loginservice: LoginService,
    private _appService: AppServiceService,
    private _authGuard: AuthGuard,
    private localSave: LocalSaveService,
  ){}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {

    const user = this.localSave.get('usuarioPGV');

    if (!user) {
      this._router.navigate(['/login']);
      return false;
    }

    // Caso normal: el ROL del usuario coincide con el de la ruta
    if (user.ROL !== next.data.ROL) {
      this._router.navigate(['/login']);
      return false;
    }

    // Si la ruta declara un `modulo` (directo o en algun hijo), validar
    // que el usuario tenga permiso_ver = 1 sobre ese modulo en sus
    // permisos cargados al login. Si no, redirige al login.
    let cursor: ActivatedRouteSnapshot = next;
    let modulo: string = null;
    while (cursor) {
      if (cursor.data && cursor.data.modulo) {
        modulo = cursor.data.modulo;
        break;
      }
      cursor = cursor.firstChild;
    }
    if (modulo) {
      const permisos = user.permisos || [];
      const tienePermiso = permisos.find(p => p.modulo === modulo && p.permiso_ver === 1);
      if (!tienePermiso) {
        this._router.navigate(['/login']);
        return false;
      }
    }

    return true;
  }

}
